import { useEffect } from "react";
import "../styles/tables.css";
import { paginateTable } from "./tablePagination";

// Adds column labels to existing tables, including sheets rendered in portals.
export default function ResponsiveTables() {
  useEffect(() => {
    const pagination = new Map();
    const prepare = () => {
      pagination.forEach((control, table) => { if (!table.isConnected) { control.destroy(); pagination.delete(table); } });
      document.querySelectorAll("table").forEach(table => {
        if (table.dataset.responsive === "custom") return;
        // Date/month/year grids belong to the picker, not the application tables.
        if (table.closest(".ant-picker-panel, .ant-picker-dropdown, .ant-calendar")) return;
        table.classList.add("app-table");
        table.parentElement?.classList.add("app-table-container");
        const headers = Array.from(table.tHead?.rows[0]?.cells || []).map(cell => cell.textContent.trim().replace(/\s+/g, " "));
        Array.from(table.tBodies).forEach(body => Array.from(body.rows).forEach(row => {
          Array.from(row.cells).forEach(cell => {
            if (cell.colSpan > 1) cell.classList.add("app-table-message");
            else if (headers[cell.cellIndex]) cell.dataset.column = headers[cell.cellIndex];
          });
        }));
        if (!["server", "none"].includes(table.dataset.pagination)) {
          if (!pagination.has(table)) pagination.set(table, paginateTable(table));
          pagination.get(table).update();
        }
      });
    };
    prepare();
    const observer = new MutationObserver(prepare);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    return () => { observer.disconnect(); pagination.forEach(control => control.destroy()); };
  }, []);
  return null;
}
